import {Observable} from 'rxjs/Observable';
import {AccountStayPreferencesDao} from '../daos/account-stay-preferences.dao';
import {Injectable} from '@angular/core';
import {LogService} from './logging.service';
import {AccountStayPreferences} from '../model/user/stay-preferences/stay-preference.model';
import {AccountPreferencesChanged} from '../model/user/stay-preferences/account-preferences-changed.model';
import {BaseService} from './base.service';
import {ServiceErrorMapper} from './mapper/service-error.mapper';
import {ServiceError} from '../model/errors/service-error.model';


const ACCOUNT_STAY_PREFERENCES_DURATION = 10 * 60 * 1000; // 10 minutes
const CLASS_NAME = 'AccountStayPreferencesService';

@Injectable()
export class AccountStayPreferencesService extends BaseService <AccountStayPreferences, string> {
  private _accountStayPreferencesObservables: Observable<AccountStayPreferences>;

  constructor(private _accountStayPreferencesDao: AccountStayPreferencesDao, private _log: LogService) {
    super(new ServiceErrorMapper(), ACCOUNT_STAY_PREFERENCES_DURATION);
    this._accountStayPreferencesObservables = new Observable<AccountStayPreferences>();
  }

  getAccountStayPreferences(useCache: boolean = false): Observable<AccountStayPreferences> {
    return this.getByKey('', useCache);
  }

  protected getFreshObservable(): Observable<AccountStayPreferences> {
    return this._accountStayPreferencesDao.get()
      .map((accountStayPreferencesData) => {
        return new AccountStayPreferences(accountStayPreferencesData, {});
      }).catch((error) => {
        const serviceError: ServiceError = this.mapError(error);
        this._log.error(`Error when getting account stay preferences`, CLASS_NAME, serviceError);
        return Observable.throw(serviceError);
      });
  }

  protected generateKey(key: string): string {
    return key;
  }

  setAccountStayPreferences(accountStayPreferences: AccountStayPreferences): Observable<AccountStayPreferences> {
    const accountStayPreferencesObservable = this._setAccountStayPreferences(accountStayPreferences);
    return this.updateFreshObservable('', accountStayPreferencesObservable);
  }

  private _setAccountStayPreferences(accountStayPreferences: AccountStayPreferences): Observable<AccountStayPreferences> {
    const formattedAccountStayPreferences: Object = new AccountPreferencesChanged(accountStayPreferences);
    return this._accountStayPreferencesDao.put(formattedAccountStayPreferences['preferences'])
      .map((accountStayPreferencesData) => {
        return new AccountStayPreferences(accountStayPreferencesData, {});
      }).catch((error) => {
        const serviceError: ServiceError = this.mapError(error);
        this._log.error(`Error when setting account stay preferences`, CLASS_NAME, serviceError);
        return Observable.throw(serviceError);
      });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/account-stay-preference.service.ts